module.exports = __webpack_public_path__ + "static/img/baihuafang.6aa6b3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/baihuafang.png
// module id = PrqK
// module chunks = 1